// packages
import { z } from 'zod'

// entities
import { privateRouteSchema } from './route'

// types
export type GenerateCheckoutLinkSchema = z.infer<typeof generateCheckoutLinkSchema>

// schemas
export const generateCheckoutLinkSchema = privateRouteSchema.extend({
  amount: z.coerce.number({ message: 'Quantidade inválida.' }).positive('Quantidade inválida.'),
  value: z.coerce
    .number({ message: 'Valor inválido.' })
    .positive('Valor inválido.')
    .min(import.meta.env.NODE_ENV === 'production' ? 10 : 1, 'Mínimo de créditos: 10.')
}) //.refine(); // TODO: cruzar pra ver se o valor e a quantidade enviados estão corretos, para não permitir compra de créditos com valor diferente do que definirmos
